import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import DeleteModalSkeleton from '../../components/Skeletons/DeleteModalSkeleton';

const DeleteTranscript = ({
  loading,
  deleteTranscriptModal,
  handleDeleteTranscript,
  handleDeleteTranscriptModalClose,
}) => {
  const { t } = useTranslation();
  const userOne = (deleteTranscriptModal.data.transcriptOneUser && deleteTranscriptModal.data.transcriptOneUser.name) || '';
  const userTwo = (deleteTranscriptModal.data.transcriptTwoUser && deleteTranscriptModal.data.transcriptTwoUser.name) || '';
  return (
    <Modal show={deleteTranscriptModal.status}>
      <ModalHeading heading={t('screens.video.transcript.deleteTitle')} />
      {loading ? (
        <DeleteModalSkeleton />
      ) : (
        <ModalForm style={{ marginBottom: '2.5rem' }}>
          <InputsSection style={{ width: '34rem' }}>
            <p className='primaryText'>
              {t('screens.video.transcript.deletePrompt', { userOne, userTwo })}
            </p>
            <p className='dangerText'>
              {t('screens.video.transcript.deleteWarn')}
            </p>
          </InputsSection>

          <ModalButtons
            submitButtonLabel={t('screens.video.transcript.deleteBtn')}
            onSubmit={handleDeleteTranscript}
            cancelButtonLabel={t('screens.video.transcript.cancel')}
            onCancel={handleDeleteTranscriptModalClose}
          />
        </ModalForm>
      )}
    </Modal>
  );
};

export default DeleteTranscript;
